import React, { useEffect, useState } from "react";
import { BottomBar } from "../../components/Footer";
import { useNavigate } from "react-router";


export function Layout({ menu, children })
{
    const [showSidebar, setShowSidebar] = useState(true);
    const navigate = useNavigate();
    // const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 900);

    useEffect(() => {
        const handleResize = () => {
            const isSmall = window.innerWidth <= 900;
            // setIsSmallScreen(isSmall);
            (isSmall) ? setShowSidebar(false) : setShowSidebar(true);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => setShowSidebar(prev => !prev);


    const signout = ()=>{
        localStorage.clear();
        navigate("/");
    }

    
    return (

        <div className="p-0">
            <div className="container-fluid border-bottom">
                <div className="d-flex justify-content-between p-2 align-items-center">
                    <div className="d-flex gap-2">
                        <span className="text-secondary border py-1 px-3 hide"> Diwane-plus <i className="bi bi-plus"></i> </span> 
                    </div> 
                    <button className={`btn btn-sm btn-secondary`} onClick={signout} >  
                        Déconnexion
                    </button>  
                </div> 
            </div>
            {/* ************************************************************************ */}   
            <div className="container-fluid"> 
                <div className="row"> 
                    {/* ************************************************************************ */}
                    <div className="sidebar d-flex flex-column p-0 pb-4 border-bottom">  
                        <div className="p-3  d-flex justify-content-end bg-three-clr border-bottom"> 
                            <button className={`btn rounded-4 text-muted sidebar-trigger`} onClick={toggleSidebar} >  
                                <i class="bi bi-list fs-3 fw-bold"></i>
                            </button>  
                        </div>
                        {showSidebar && (
                        <div className={`d-flex flex-column p-0`}>
                            <a className={`border-bottom p-3 sidebar-menu ${ (menu === 1) ? 'sidebar-menu-active' : null } `} href={ "/admin" } >
                                <div className="d-flex flex-column justify-content-center align-items-center"> 
                                    <i className="bi bi-grid-fill fs-3 text-blue-clr"></i>
                                    <span className="text-secondary mt-2"> Généralité </span> 
                                </div>
                            </a>
                            <a className={`border-bottom p-3 sidebar-menu ${ (menu === 2) ? 'sidebar-menu-active' : null } `} href={ "/admin/services" } >
                                <div className="d-flex flex-column justify-content-center align-items-center"> 
                                    <i className="bi bi-briefcase-fill fs-3 text-blue-clr"></i>
                                    <span className="text-secondary mt-2"> Services </span> 
                                </div>
                            </a>
                            <a className={`border-bottom p-3 sidebar-menu ${ (menu === 3) ? 'sidebar-menu-active' : null } `} href={ "/admin/entreprise" } >
                                <div className="d-flex flex-column justify-content-center align-items-center"> 
                                    <i className="bi bi-building-fill fs-3 text-blue-clr"></i>  
                                    <span className="text-secondary mt-2"> Entreprises </span> 
                                </div>
                            </a>
                            <a className={`border-bottom p-3 sidebar-menu ${ (menu === 4) ? 'sidebar-menu-active' : null } `} href={ "/admin/notification" } >
                                <div className="d-flex flex-column justify-content-center align-items-center"> 
                                    <i className="bi bi-bell-fill fs-3 text-blue-clr"></i>
                                    <span className="text-secondary mt-2"> Notification </span> 
                                </div>
                            </a>
                            <a className={`border-bottom p-3 sidebar-menu ${ (menu === 5) ? 'sidebar-menu-active' : null } `} href={ "/admin/parametre" } >
                                <div className="d-flex flex-column justify-content-center align-items-center"> 
                                    <i className="bi bi-gear-fill fs-3 text-blue-clr"></i>
                                    <span className="text-secondary mt-2"> Paramétres </span> 
                                </div>
                            </a>
                        </div>
                        )}
                    </div>
                    {/* ************************************************************************ */}
                    <div className="panel p-0 border-start"> { children } </div>
                </div>
            </div>
            {/* ************************************************************************ */}
            <div className="container-fluid level bg-blue-clr"> 
                <BottomBar /> 
            </div>
            {/* ************************************************************************ */} 
        </div>
    )
}


